var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { NotificationContainer, Message, Label, UnreadBubble, MarkAsUnreadBubble, } from './styles';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { useMutation, useQueryCache } from 'react-query';
import api from 'src/Utils/api';
import { NOTIFICATIONS_API, NOTIFICATIONS_UNREAD_COUNT_API } from 'src/Utils';
function Notification(_a) {
    var _this = this;
    var notification = _a.notification;
    var history = useHistory();
    var queryCache = useQueryCache();
    var _b = useMutation(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.put("/ticket_notifications/" + notification.id + "/mark_as_read", {})];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            queryCache.invalidateQueries(NOTIFICATIONS_API);
        },
    }), markAsRead = _b[0], markAsReadResult = _b[1];
    var _c = useMutation(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.put("/ticket_notifications/" + notification.id + "/mark_as_unread", {})];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            queryCache.invalidateQueries(NOTIFICATIONS_API);
        },
    }), markAsUnread = _c[0], markAsUnreadResult = _c[1];
    var handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!notification.read_at) return [3 /*break*/, 2];
                    return [4 /*yield*/, markAsRead()];
                case 1:
                    _a.sent();
                    queryCache.invalidateQueries(NOTIFICATIONS_UNREAD_COUNT_API);
                    _a.label = 2;
                case 2:
                    history.push("/tickets/" + notification.ticket_id);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMarkAsRead = function (event) {
        event.stopPropagation();
        markAsRead();
    };
    var handleMarkAsUnread = function (event) {
        event.stopPropagation();
        markAsUnread();
    };
    return (React.createElement(NotificationContainer, { onClick: handleClick },
        !notification.read_at && (React.createElement(Tooltip, { title: "Marcar como le\u00EDda" },
            React.createElement(UnreadBubble, { onClick: handleMarkAsRead, disabled: markAsReadResult.isLoading, className: "unread-bubble" }))),
        notification.read_at && (React.createElement(Tooltip, { title: "Marcar como no le\u00EDda" },
            React.createElement(MarkAsUnreadBubble, { onClick: handleMarkAsUnread, disabled: markAsUnreadResult.isLoading, className: "mark-as-unread-bubble" }))),
        React.createElement(Message, null, notification.message),
        React.createElement(Label, null,
            React.createElement("span", null,
                "Ticket #",
                notification.ticket_number),
            React.createElement("span", null, dayjs(notification.created_at).fromNow()))));
}
export default Notification;
